module.exports = __webpack_public_path__ + "img/sh.68a91926.svg";